export default __webpack_public_path__ + "static/media/PDFINVOICEFEE.f49f3d7f.png";